import React, { PropTypes } from 'react';
import first from 'lodash/first';
import NegativeFeedback from 'project/containers/entries/negative_feedback';
import PositiveFeedback from 'project/containers/entries/positive_feedback';
import Thumbnail from 'common/components/thumbnail';

const POSITIVE_THRESHOLD = 3;

const Feedback = ({
  thumbnails, name, score, feedbackSent, author_username, entry_type, hideThumbnail
}) => {
  const thumbnailImage = entry_type === 'name'? null : first(thumbnails);

  return (<div className="feedback-wrapper">
    <div className="feedback-wrapper-header">
      { score > POSITIVE_THRESHOLD ?
      <h5>We&apos;re glad you like it!</h5> :
      <h5>Help {author_username} improve this entry</h5> }
    </div>
    <div className="feedback-wrapper-content">
      <div className="row">
        { !feedbackSent?
        <div className={"columns small-16 " + (!hideThumbnail? "medium-11":"")}>
          { score > POSITIVE_THRESHOLD ? <PositiveFeedback /> : <NegativeFeedback /> }
        </div>:
        <div className={"columns small-16 feedback-send-success text-center "
                        + (!hideThumbnail? "medium-11":"")}>
          <div>
            <i className="fa fa-check-circle text-success" />
            <h3>Thanks for your feedback!</h3>
          </div>
        </div> }

        {!hideThumbnail &&
        <div className="columns small-16 medium-5 hide-for-small-only">
          <Thumbnail className="entry-thumbnail" image={thumbnailImage}>
            { entry_type === 'name' && <div className="revision-name">{ name }</div> }
          </Thumbnail>
        </div>}
      </div>
    </div>
  </div>);
};

Feedback.propTypes = {
  thumbnails: PropTypes.array,
  name: PropTypes.string,
  score: PropTypes.number,
  feedbackSent: PropTypes.bool,
  author_username: PropTypes.string,
  entry_type: PropTypes.string,
  hideThumbnail: PropTypes.bool,
};

export default Feedback;



// WEBPACK FOOTER //
// ./project/components/entries/feedback.jsx